import { defineComponent as _defineComponent } from 'vue';
import moment from 'moment';
import { computed, ref, watch } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ScheduleForm',
    props: {
        value: null
    },
    emits: ["input"],
    setup(__props, { emit }) {
        const props = __props;
        const weeks = [
            {
                text: 'Sunday',
                value: 'Sun',
            },
            {
                text: 'Monday',
                value: 'Mon'
            },
            {
                text: 'Tuesday',
                value: 'Tue'
            },
            {
                text: 'Wednesday',
                value: 'Wed'
            },
            {
                text: 'Thursday',
                value: 'Thu'
            },
            {
                text: 'Friday',
                value: 'Fri'
            },
            {
                text: 'Saturday ',
                value: 'Sat'
            },
        ];
        const months = [
            {
                text: 'January',
                value: 'Jan'
            },
            {
                text: 'February',
                value: 'Feb'
            },
            {
                text: 'March',
                value: 'Mar'
            },
            {
                text: 'April',
                value: 'Apr'
            },
            {
                text: 'May',
                value: 'May'
            },
            {
                text: 'June',
                value: 'Jun'
            },
            {
                text: 'July',
                value: 'Jul'
            },
            {
                text: 'August',
                value: 'Aug'
            },
            {
                text: 'September',
                value: 'Sep'
            },
            {
                text: 'October',
                value: 'Oct'
            },
            {
                text: 'November',
                value: 'Nov'
            },
            {
                text: 'December',
                value: 'Dec'
            },
        ];
        const rangeMenu = ref(false);
        const schedule = computed({
            get() {
                return props.value ?? { times: [moment().format('HH:mm')], enabledDateRange: [], months: [], weekdays: [] };
            },
            set(newValue) {
                emit('input', newValue);
            }
        });
        watch(schedule, (newValue) => {
            if (newValue.enabledDateRange.length > 0)
                return;
            if (newValue.months.length > 0)
                return;
            if (newValue.weekdays.length > 0)
                return;
            if (newValue.times.length > 0)
                return;
            addCronTime();
        }, { deep: true });
        function addCronTime() {
            const scheduleCopy = schedule.value;
            scheduleCopy.times.push(moment().format('HH:mm'));
            schedule.value = scheduleCopy;
        }
        function removeCronTime(index) {
            const scheduleCopy = schedule.value;
            scheduleCopy.times.splice(index, 1);
            schedule.value = scheduleCopy;
        }
        function disablePastDates(val) {
            return val >= new Date().toISOString().substring(0, 10);
        }
        watch(schedule, (newSchedule) => {
            emit('input', newSchedule);
        });
        return { __sfc: true, emit, props, weeks, months, rangeMenu, schedule, addCronTime, removeCronTime, disablePastDates };
    }
});
